;(function() {
  'use strict'

  SurveyBuilderConfig.$inject = ["$stateProvider"];
  angular.module('app.core').config(SurveyBuilderConfig)

  /* @ngInject */
  function SurveyBuilderConfig($stateProvider) {
    $stateProvider.state('app.surveyBuilder', {
      url: '/survey-builder',
      templateUrl: 'survey-builder.html',
      controller: 'SurveyBuilder',
      controllerAs: '$ctrl',
    })
  }
})()
